import { useState } from 'react';

const useInput = (props) => {
    const [value, setValue] = useState(props.value);
    const [valid, setValid] = useState(true);
    const [status, setStatus] = useState('normal');

    const onChange = (event, _value) => {
        setValue(_value);
        setValid(true);
        setStatus('normal');
        if (props.onChange) {
            props.onChange(event, _value);
        }
    };

    const setError = () => {
        setValid(false);
        setStatus('error');
    };

    return {
        props: {
            value,
            onChange,
            status,
        },
        value,
        valid,
        setValid,
        setStatus,
        setError,
        onChange,
    };
};

export default useInput;
